import $ from 'jquery';

// We attempt to send this data in the most async friendly way possible.
// In order, these are the following:
//
// 1. fetch(url, {keepalive: true})
//    The modern replacement for navigator.sendBeacon(). Creates a request
//    that outlives the page, with all the power of fetch() behind it.
//    As of September 2019, only supported by Chrome.
//
// 2. navigator.sendBeacon(url)
//    The old way to create a request that outlives the page. Can't send
//    json, so we must use a query parameter. Can't send arbitrary headers.
//    Limited to 8 KB of data by Nginx's large_client_header_buffers param.
//    Supported by all modern browsers but not IE.
//
// 3. fetch(url)
//    A synchronous request. Will be canceled within a beforeunload handler.
//    Polyfilled by us.

export function keptAlivePost(
  url: string,
  body: object,
): Promise<Response> | void {
  const jsonBody = JSON.stringify(body);
  const beaconUrl = `${url}&${$.param({ body: jsonBody })}`;

  const csrfToken = document.querySelector<HTMLMetaElement>(
    "[name='csrf-token']",
  )?.content;

  if (
    'keepalive' in new Request('https://www.example.com') ||
    !navigator.sendBeacon ||
    beaconUrl.length > 8000
  ) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken as string,
      },
      keepalive: true,
      mode: 'same-origin',
      body: jsonBody,
    });
  } else {
    // Beacons don't send headers, which includes the X-CSRF-Token header
    // API calls will fail with a 403.
    // To fix this, make sure the controller uses beacon_reception_mixin.rb.
    navigator.sendBeacon(beaconUrl);
  }
}
